import { createSlice } from '@reduxjs/toolkit'

const initialReviewsState = {
	listLoading: false,
	actionsLoading: false,
	totalCount: 0,
	entities: [],
	reviewForEdit: undefined,
	lastError: null,
}
export const callTypes = {
	list: 'list',
	action: 'action',
}

export const reviewsSlice = createSlice({
	name: 'reviews',
	initialState: initialReviewsState,
	reducers: {
		catchError: (state, action) => {
			state.error = `${action.payload.error}`
			if (action.payload.callType === callTypes.list) {
				state.listLoading = false
			} else {
				state.actionsLoading = false
			}
		},
		startCall: (state, action) => {
			state.error = null
			if (action.payload.callType === callTypes.list) {
				state.listLoading = true
			} else {
				state.actionsLoading = true
			}
		},
		// getReviewById
		reviewFetched: (state, action) => {
			state.actionsLoading = false
			state.reviewForEdit = action.payload.reviewForEdit
			state.error = null
		},
		// findReviews
		reviewsFetched: (state, action) => {
			const { totalCount, entities } = action.payload
			state.listLoading = false
			state.error = null
			state.entities = entities
			state.totalCount = totalCount
		},
		// createReview
		reviewCreated: (state, action) => {
			state.actionsLoading = false
			state.error = null
			state.entities.unshift(action.payload.data)
		},
		// updateReview
		reviewUpdated: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.map((entity) => {
				if (entity.id === action.payload.review.id) {
					return action.payload.review
				}
				return entity
			})
		},
		// deleteReview
		reviewDeleted: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.filter(
				(el) => el.id !== action.payload.id,
			)
		},
		// deleteReviews
		reviewsDeleted: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.filter(
				(el) => !action.payload.ids.includes(el.id),
			)
		},
		// reviewsUpdateState
		reviewsStatusUpdated: (state, action) => {
			state.actionsLoading = false
			state.error = null
			const { ids, status } = action.payload
			state.entities = state.entities.map((entity) => {
				if (ids.findIndex((id) => id === entity.id) > -1) {
					entity.status = status
				}
				return entity
			})
		},
		// reviewsUpdateState
		reviewStatusUpdated: (state, action) => {
			state.actionsLoading = false
			state.error = null
			const { id, status } = action.payload
			state.entities = state.entities.map((entity) => {
				if (id === entity.id) {
					entity.status = status
				}
				return entity
			})
		},
	},
})
